import { css } from "@emotion/css";
import { EnvironmentIcon, ParentEnvironmentIcon } from "@octopusdeploy/design-system-icons";
import { space, text, themeTokens } from "@octopusdeploy/design-system-tokens";
import type { EnvironmentType } from "@octopusdeploy/octopus-server-client";
import React from "react";
import Card from "~/components/Card";
import InfoDialogLayout from "~/components/DialogLayout/InfoDialogLayout";
interface EnvironmentTypeDialogLayoutProps {
    onSelectType: (type: EnvironmentType) => void;
}
export const EnvironmentTypeDialogLayout = (props: EnvironmentTypeDialogLayoutProps) => {
    const cardContainer = css({
        display: "flex", // displays cards side by side
    });
    return (<InfoDialogLayout title={<h2 className={styles.dialogTitle}>Select Environment Type</h2>} closeButtonLabel="Cancel">
            <div className={cardContainer}>
                <Card onClick={() => props.onSelectType("Static")} logo={<EnvironmentIcon size={24} color={themeTokens.color.icon.info}/>} header={<div className={styles.cardHeader}>Environment</div>} content="An environment groups together all the deployment targets used to host your software application." className={styles.card} contentClassName={styles.content} leftAlign={true}/>
                <Card onClick={() => props.onSelectType("Parent")} logo={<ParentEnvironmentIcon size={24} color={themeTokens.color.icon.info}/>} header={<div className={styles.cardHeader}>Parent Environment</div>} content="A parent environment groups ephemeral environments and can't be deployed to directly." className={styles.card} contentClassName={styles.content} leftAlign={true}/>
            </div>
        </InfoDialogLayout>);
};
export default EnvironmentTypeDialogLayout;
const styles = {
    card: css({
        "&&": {
            flex: 1,
            minWidth: "100%",
            width: "auto",
            padding: space[16],
            paddingTop: space[12],
            backgroundColor: "var(--paper2)", // Following model of InfraOverviewCard background color
            cursor: "pointer",
            "@media (min-width: 600px)": {
                minWidth: "auto",
            },
        },
    }),
    dialogTitle: css({ font: text.heading.large, margin: 0 }),
    cardHeader: css({
        font: text.body.bold.medium,
        margin: 0,
        marginBottom: space[4],
        // The card component adds padding to only the heading for small screen sizes, this cancels that out
        "@media (max-width: 600px)": {
            marginLeft: -8,
        },
    }),
    content: css({
        "&&": {
            width: "auto",
            font: text.body.regular.small,
            margin: 0,
            // The card component hides the content on small screen sizes by default
            display: "block",
        },
    }),
};
